import { Inject, Injectable, InjectionToken } from '@angular/core';
import { RoiStore, RoiChangeStore } from '../../stores';
import { RestoreUnsavedChangesUseCase } from '@analysis/use-cases';
import { from, Observable, EMPTY } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

export type RestoreUnsavedChangesPayload = {
  sampleId: string;
  analystId: string;
};

export const RESTORE_UNSAVED_CHANGES_USE_CASE = new InjectionToken<RestoreUnsavedChangesUseCase>(
  'RESTORE_UNSAVED_CHANGES_USE_CASE'
);

@Injectable()
export class RoiRestoreEffects {
  constructor(
    private readonly roiStore: RoiStore,
    private readonly roiChangeStore: RoiChangeStore,
    @Inject(RESTORE_UNSAVED_CHANGES_USE_CASE)
    private readonly restoreUnsavedChangesUseCase: RestoreUnsavedChangesUseCase
  ) {}

  readonly restoreUnsavedChanges = this.roiStore.effect((payload$: Observable<RestoreUnsavedChangesPayload>) =>
    payload$.pipe(
      tap(() => {
        this.roiChangeStore.resetForRestoration();
        this.roiStore.clearError();
      }),
      switchMap(({ sampleId, analystId }) =>
        from(this.restoreUnsavedChangesUseCase.execute({ sampleId, analystId })).pipe(
          tap((changes) => {
            this.roiChangeStore.setRestoredChanges(changes);
          }),
          catchError((error) => {
            this.roiStore.setError(error.message);
            this.roiChangeStore.markChangeRestorationComplete();
            return EMPTY;
          }),
          map(() => void 0)
        )
      )
    )
  );
}
